import {Component, Input, OnInit} from '@angular/core';
import {LabOrder} from '../../shared/data/lab-order';
import { LensCatalogBusinessService } from '../../shared/lens-catalog-business.service';
import { LensFeature } from '../../shared/data/lens-feature';
import { UtilsService } from '../../shared/utils.service';

@Component({
  selector: 'app-bevel',
  templateUrl: './bevel.component.html',
  styleUrls: ['./bevel.component.css']
})
export class BevelComponent implements OnInit {

  // provide constant for lens-feature other value id.
  OTHER_BEVEL_ID = 'OTHER_BEVEL';
  OTHER_EDGE_ID = 'OTHER';

  @Input() labOrder: LabOrder;

  // Arrays of Coating objects to populate the drop down lists' options
  edges: LensFeature[];
  bevel: LensFeature[];
  
  constructor(
    private lensCatalogBusinessService: LensCatalogBusinessService
  ) { }

  ngOnInit(): void {

    // remove any features before set on component. 
    this.edges = this.removeVSPOther(this.lensCatalogBusinessService.edges);
    this.bevel = this.removeVSPOther(this.lensCatalogBusinessService.bevel);
  }

  // For all VSP orders (not private) remove 'Other'
  removeVSPOther(lensFeatures: LensFeature[]): LensFeature[] {
    if (! UtilsService.isPrivateOrder(this.labOrder) && lensFeatures) {
      // keep the feature if value doesn't start with 'OTHER'
      lensFeatures = lensFeatures.filter(feature => !feature.catalogApiEnum.startsWith('OTHER'));  
    }
    return lensFeatures;
  }

  // if the bevel code drop-down is not 'OTHER_BEVEL' then
  // clear the bevel description.
  clearBevelDescription(bevelValue) {

    if (bevelValue !== this.OTHER_BEVEL_ID) {
      this.labOrder.lens.bevelDescription = '';
    }
  }

  // determine if bevel description should be disabled.
  otherBevelDisable(): boolean {
    return this.labOrder.lens.bevelCode !== this.OTHER_BEVEL_ID;
  }

  // if the edge code drop-down is not 'OTHER' then
  // clear the edge description.
  clearEdgeDescription(edgeValue) {

    if (edgeValue !== this.OTHER_EDGE_ID) {
      this.labOrder.lens.edgeDescription = '';
    }
  }

  // determine if edge description should be disabled.
  disableEdgeDescription(): boolean {
    return this.labOrder.lens.edgeCode !== this.OTHER_EDGE_ID;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/modify-order/bevel/bevel.component.ts